import React from "react";
import { CheckCircle2, Circle, Clock, Flame } from "lucide-react";

const getIntensityColor = (intensity) => {
  switch (intensity) {
    case 'low': return 'text-green-500 bg-green-100';
    case 'medium': return 'text-amber-500 bg-amber-100';
    case 'high': return 'text-red-500 bg-red-100';
    default: return 'text-sky-500 bg-sky-100';
  }
};

export const ExerciseItem = ({ exercise, isCompleted, onToggle, type, index, t }) => {
  const isPhysical = type === 'physical';
  const colors = isPhysical
    ? { completed: 'bg-cyan-50 border-cyan-200', text: 'text-cyan-700', hover: 'hover:border-cyan-200', check: 'text-cyan-500' }
    : { completed: 'bg-indigo-50 border-indigo-200', text: 'text-indigo-700', hover: 'hover:border-indigo-200', check: 'text-indigo-500' };

  return (
    <div 
      className={`p-4 rounded-xl border-2 transition-all duration-300 cursor-pointer
        ${isCompleted ? colors.completed : `bg-white/50 border-white/60 ${colors.hover}`}`}
      onClick={() => onToggle(exercise.id, type)}
      data-testid={`${type}-exercise-${index}`}
    >
      <div className="flex items-start gap-3">
        <div className="mt-1">
          {isCompleted ? (
            <CheckCircle2 className={`w-5 h-5 ${colors.check}`} />
          ) : (
            <Circle className="w-5 h-5 text-slate-300" />
          )}
        </div>
        <div className="flex-1">
          <h3 className={`font-medium ${isCompleted ? `${colors.text} line-through` : 'text-sky-800'}`}>
            {exercise.name}
          </h3>
          <p className="text-sm text-slate-500 mt-1">{exercise.description}</p>
          <div className="flex items-center gap-3 mt-2">
            <span className="flex items-center gap-1 text-xs text-slate-500">
              <Clock className="w-3 h-3" />
              {exercise.duration_minutes} {t('common.minutes')}
            </span>
            {isPhysical ? (
              <>
                <span className={`flex items-center gap-1 text-xs px-2 py-0.5 rounded-full ${getIntensityColor(exercise.intensity)}`}>
                  <Flame className="w-3 h-3" />
                  {t(`training.intensity.${exercise.intensity}`, exercise.intensity)}
                </span>
                {exercise.category && (
                  <span className="text-xs text-slate-400">{exercise.category}</span>
                )}
              </>
            ) : (
              exercise.type && (
                <span className="text-xs px-2 py-0.5 rounded-full bg-indigo-100 text-indigo-600">
                  {exercise.type}
                </span>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
